import {Modal, Col, Row, Icon, Button, Tooltip, Divider, Input, TextArea} from 'antd';
import {ssDateUtils } from '@bit/ui-common.ui-components/ss-utils';
const
PHOTO_UPLOAD_ACTION='PU',
TR_JSON_PART='dodStatus',
TR_PHOTO_PART='photoUpload',
{ unixSecondsToDateString } = ssDateUtils;

export default class EndorseePhotoModal extends React.Component {

    constructor(props) { 
        super(props);
        this.getEndorseeHover = this.props.getEndorseeHover.bind(this);
    }
    state = {dodPhotoModal: null,
        file: null,
        uploadError: null,
        comments: null,
        uploadReady: false,
        uploadPhoto: false,
        badFile: false};
    componentDidMount() {
        this.setState({dodPhotoModal: this.props.dodPhotoModal});
        if(this.props.endorsementId) {
            this.props.services.getAllDodPhotos(this.props.endorsementId);
        }
    }
    componentDidUpdate(prevProps) {
        const { page, pageSize, tableSearch} = this.props;
        if (prevProps.dodPhotoModal != this.props.dodPhotoModal) {
            this.setState({dodPhotoModal: this.props.dodPhotoModal});
        }
        if(prevProps.trainingRequestsPhotoUpload.photoUploaded == false 
            && this.props.trainingRequestsPhotoUpload.photoUploaded == true) {
                this.props.services.getAllDodPhotos(this.props.endorsementId);
                this.props.services.getEndorsementsData(page, pageSize, null, null, tableSearch);
            }
    }

    closeModal = () => {
        const {page, pageSize, tableSearch, services} = this.props;
        this.setState({dodPhotoModal: false});
        services.clearDodPhotoData();

    }

    // Function to check and raise error message based on allowable file type (MIME TYPE).
    checkMimeType = (event) => {
        
        // Getting file object
        let files = event.target.files 
            
        // Define error message
        let err = []
        this.setState({uploadError: undefined, badFile: false});
        
        // List of allowable mime type
        const types = ['image/png', 'image/jpeg', 'image/gif', 'application/pdf']
        // Loop access array
        for(var x = 0; x < files.length; x++) {
             
            // Compare file type that does not match the allowable types 
            if (types.every(type => files[x].type !== type)) {
                 
            // Create error message  
            err[x] = files[x].type + ' file is not a supported type\n';
           }
        }
    
        // Loop to set the error message 
        for(var z = 0; z < err.length; z++) { 
            // Discard selected file
            this.setState({uploadError: err[z], uploadReady: false, badFile: true});
            event.target.value = null
            return false;
        }
        return true;
    }
    
    // Check file size and display error message if exceeds allowable size limit
    checkFileSize = (event) => {
            
        let files = event.target.files
        let maxFileSize = 10240000; // 10MB -> 10000 * 1024 is the allowable size
        let err = []; 
        this.setState({uploadError: undefined, badFile: false});
        for(var x = 0; x < files.length; x++) {
            if (files[x].size > maxFileSize) {             
                err[x] = files[x].type +' exceeds the 10MB limit, please upload a smaller file.\n';
                this.setState({uploadError: err[x], badFile: true});
                return false;  
            }
        }
        return true;
    }
        
    checkAltered = (event) => {
        var validFileTypes1 = ['.pdf','.png','.jpg','.gif'];
        var validFileType = false;
        this.setState({uploadError: undefined, badFile: false});
        let files = event.target.files
    
        if (files[0] != null) {
            for (var i = 0; i < validFileTypes1.length; i++) {
                if (files[0].name.slice(-4).toLowerCase() === validFileTypes1[i]) {
                    validFileType = true;
                }
            }
            if (validFileType == false) {
                this.setState({uploadError: 'file type not supported', uploadReady: false, badFile: true});
            }else {
                var mimeTypePromise = this.getMimeType(files[0]);
                mimeTypePromise.then(result => {
                    if(result == files[0].type) {
                        this.setState({uploadError: undefined, badFile: false});
                    }else if(result == "unknown") {
                        this.setState({uploadError: 'file type not supported', uploadReady: false, badFile: true});
                    }else {
                        this.setState({uploadError: 'Altered File Extension does not align with file type', uploadReady: false, badFile:true});
                    }
                });
            }
        }
        return validFileType;
    }
    
    getMimeType(file) {
        return new Promise((resolve) => {
            var reader = new FileReader();
            var header = "";
    
            reader.onloadend = function(e) {
                var arr = (new Uint8Array(e.target.result)).subarray(0,2);
                for(var i = 0; i < arr.length; i++) {
                    header += arr[i].toString(16);
                }
                switch (header) {
                    case "8950":
                        resolve("image/png");
                        break;
                    case "4749":
                        resolve("image/gif");
                        break;
                    case "2550":
                        resolve("application/pdf");
                        break;
                    case "ffd8":
                        resolve("image/jpeg");
                        break;
                    default:
                        resolve("unknown");
                    }
                };
            reader.readAsArrayBuffer(file);
        });
    }
    



    selectFile = event => {
        //If no errors from file type and file size checks then proceed with file upload
        if(this.checkMimeType(event) &&  this.checkFileSize(event) && this.checkAltered(event)){ 
            const { services } = this.props;
            this.setState({file: event.target.files[0], uploadReady: true, uploadPhoto: true }) 
            services.updateTrainingRequestsPhotoUpload('valid', 'file-content');
       }else{
            this.setState({file: event.target.files[0], uploadPhoto: false }) 

       }
    }

    submitFile = () => {
        const { services } = this.props;
        if(this.state.uploadReady && !this.state.badFile) {
            services.submitEndorsementPhotoUpload(this.getFormData());
            
            this.setState({file: null, comments: null, uploadReady: false});
            let fileInput = document.getElementById('fileInput');
            fileInput.value ='';
            

        }
    }
    updateComment = event => {
        const targetValue = event.target.value;
        for(let i = 0; i < targetValue.length; i++) {
            if(targetValue[i].charCodeAt(0) < 32 || targetValue[i].charCodeAt(0) > 127 ){
                this.setState({uploadError: 'Enter only letters, numbers, and allowable special characters'});
                return;
            }
        }
        if(targetValue != '') {
            if(!this.state.badFile) {
                this.setState({comments: targetValue, uploadReady: true, uploadError: undefined});
            }else{
                this.setState({comments: targetValue, uploadReady: false, uploadError: undefined});
            }
        }else{
            if(targetValue == '' && !this.state.uploadPhoto) {
                this.setState({comments: targetValue, uploadReady: false, uploadError: undefined});
            }else{
                this.setState({comments: targetValue, uploadError: undefined});
            }
        }
    }
    deletePhoto =(imgId)=> {
        const { services } = this.props;
        services.deleteDodPhoto(this.props.endorsementId, imgId);
    }
    getFormData() {
        const
        { file } = this.state,
        validationRequest = {
            id: this.props.endorsementId,
            userName: this.props.userName,
            trainingRequestStatus: PHOTO_UPLOAD_ACTION,
            comments: this.state.comments
        };
        if(file == null) return JSON.stringify(validationRequest);
        else {
            const
            formData  = new FormData(),
            blob = new Blob([JSON.stringify(validationRequest)], { type: 'application/json' });
            formData.append(TR_JSON_PART, blob);
            formData.append(TR_PHOTO_PART, file, file.name);
            return formData;
        }
    }

    
    render() {
        const {trainingRequestsPhotoUpload, services} = this.props,
              {uploadReady, uploadPhoto} = this.state;
        const rows = [];
        const readOnly = window.session.jwtSession["read-only"] == undefined || window.session.jwtSession["read-only"] != true ? false: true;
        if(trainingRequestsPhotoUpload.fileInfo) {
            trainingRequestsPhotoUpload.fileInfo.map((photos =>(
                rows.push(
                    <div key={photos.id}>
                    {photos.imgName=='NoImgComment' ? 
                        <p style={{overflowWrap: 'break-word',
                                maxWidth: '200px'}}>{photos.comments }</p>
                        :
                        <Tooltip title={()=> this.getEndorseeHover(photos.uploadUserid, unixSecondsToDateString(photos.createdDate), photos.imgName, photos.mimetype, photos.image, photos.comments, 'Y')}
                            overlayStyle={{maxWidth: 'max-content'}}>
                            {photos.mimetype=='application/pdf' ? <Icon type='file-pdf' style={{fontSize: '72px'}}/> :
                            <a target='_blank'>
                            <img src={'data:'+photos.mimetype+';base64,'+photos.image}
                            style={{width: '100px'}}/>
                            </a>
                            }
                            
                        </Tooltip>}
                        {readOnly ? null :
                        <Icon type='close' style={{backgroundColor: 'red'}} onClick={()=> this.deletePhoto(photos.id)}/>}
                        
                        </div>
                )

        )));}
        return (
            <div>
                <Modal 
                    visible={this.state.dodPhotoModal}
                    closable={false}
                    centered={true}
                    footer={false}
                    width={700}
                >
                    <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '15px' }}>
                        <Col>
                            <span className='provider-endorsement-email-modal-header' style={{color: this.props.trainingRequestsPhotoUpload.dodEndorseeColor}}>
                                {this.props.trainingRequestsPhotoUpload.dodEndorseeTitle}
                            </span>
                        </Col>
                    </Row>
                    <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '15px' }}>
                    {rows}
                    </Row>
                    
                    <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '-14px' }}>
                        <Col span={20} style={{ textAlign: 'left' }}>
                            <Row type='flex' justify='space-around' align='middle'>
                                <Col span={20} style={{ textAlign: 'left', lineHeight: '16px' }}>
                                    <ul>
                                        
                                        <li>
                                            <span style={{ fontStyle: 'italic' }}>{
                                                'You are required to upload a photograph, before commencing training. ' +
                                                'If you are unable to do so, for any reason, you must provide an explanation.'
                                            }</span>
                                        </li>
                                    </ul>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Divider type='horizontal' />

                    <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '16px' }}>
                        <Col span={20}>
                            <Row type='flex' justify='space-around' align='middle'>
                                <Col style={{ textAlign: 'left', marginRight: '-70px', lineHeight: '16px' }}>
                                    <div style={{ marginBottom: '6px' }}>
                                        <span style={{ fontWeight: 'bold', fontStyle: 'italic', marginBottom: '4px' }}>
                                            {'I have a photo of the student'}
                                        </span>
                                    </div>
                                    <input name='photoUpload' id='fileInput' type='file' accept={'.pdf,.png,.jpg,.gif'} disabled={readOnly} onChange={(e)=>this.selectFile(e)}/>
                                    <div>              
                                        <span style={{color: 'red', marginLeft:'1px'}}>
                                            {this.state.uploadError}
                                        </span>
                                    </div>
                                   
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: '16px'}}>
                        <Col span={24} style={{ lineHeight: '20px' }}>
                            <div>
                                <span style={{ fontWeight: 'bold', fontStyle: 'italic' }}>
                                    {'I am unable to upload a photo:'}
                                </span>
                            </div>
                            <div style={{
                                marginTop: '-5px',
                                marginBottom: '4px',
                                fontStyle: 'italic'
                            }}>
                                <span>
                                    {'Please indicate the reason why you are unable to upload a photo.'}
                                </span>
                            </div>
                            <Input.TextArea
                                id='TrPhotoUpload-InputTextArea-AdditionalComments'
                                name='commentInput'
                                rows={2}
                                placeholder='Please indicate reason in this text area.'
                                onChange={(e)=>this.updateComment(e)}
                                maxLength={200}
                                value={this.state.comments}
                                disabled={readOnly}
                            />
                        </Col>
                    </Row>
                    <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '15px' }}>
                            <Button disabled={!uploadReady} 
                            style={{backgroundColor: (uploadReady ? '#003366' : ''),
                                    color: (uploadReady ? 'white' : '')}}  
                            onClick={()=>this.submitFile()} >{'Submit'}</Button>
                            <Button onClick={() => this.closeModal()}>{'Close'}</Button>
                    </Row>

                    
                </Modal>
            </div>
        );
    }
}
